var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreece(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.752888C22.3139 0.75336 22.6743 0.886607 22.9401 1.1234C23.2059 1.36019 23.3555 1.68122 23.356 2.0161V19.7222C23.3555 20.0571 23.2059 20.3781 22.9401 20.6149C22.6743 20.8517 22.3139 20.985 21.938 20.9854H2.06201C1.6861 20.985 1.32572 20.8517 1.05991 20.6149C0.7941 20.3781 0.644523 20.0571 0.643994 19.7222V2.0161C0.644523 1.68122 0.7941 1.36019 1.05991 1.1234C1.32572 0.886607 1.6861 0.75336 2.06201 0.752888H21.938ZM21.938 0.179199H2.06201C1.5153 0.179671 0.991126 0.373361 0.604541 0.717742C0.217956 1.06212 0.000529505 1.52907 0 2.0161V19.7222C0.000529505 20.2092 0.217956 20.6762 0.604541 21.0206C0.991126 21.365 1.5153 21.5586 2.06201 21.5591H21.938C22.4845 21.5582 23.0084 21.3643 23.3949 21.02C23.7813 20.6758 23.9989 20.2091 24 19.7222V2.0161C23.9995 1.52907 23.782 1.06212 23.3955 0.717742C23.0089 0.373361 22.4847 0.179671 21.938 0.179199Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643921 19.722C0.64445 20.0569 0.794027 20.3779 1.05984 20.6147C1.32565 20.8515 1.68602 20.9847 2.06194 20.9852H21.9379C22.3138 20.9847 22.6742 20.8515 22.94 20.6147C23.2058 20.3779 23.3554 20.0569 23.3559 19.722V19.1875H0.643921V19.722Z",
    fill: "#005DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33591 0.75293H2.06194C1.68602 0.753401 1.32565 0.886649 1.05984 1.12344C0.794027 1.36024 0.64445 1.68127 0.643921 2.01614V4.91669H5.33591V0.75293Z",
    fill: "#005DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33591 7.29688H0.643921V12.0486H5.33591V7.29688Z",
    fill: "#005DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.75293H8V4.91669H13.336V2.53994H23.348V2.01614C23.3475 1.6825 23.199 1.36251 22.9349 1.12592C22.6708 0.889331 22.3125 0.755279 21.938 0.75293Z",
    fill: "#005DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3559 4.92041H13.3439V7.29533H23.3559V4.92041Z",
    fill: "#005DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3559 14.4287H0.643921V16.8037H23.3559V14.4287Z",
    fill: "#005DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.344 7.29688H8.008V12.0486H23.356V9.67362H13.344V7.29688Z",
    fill: "#005DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3559 16.8037H0.643921V19.184H23.3559V16.8037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3439 4.91669H8.00793V0.75293H5.33591V4.91669H0.643921V7.29696H5.33591V12.0487H0.643921V14.4289H23.3559V12.0487H8.00793V7.29696H13.3439V9.67371H23.3559V7.29339H13.3439V4.92026H23.3559V2.53994H13.3439V4.91669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.179199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/Greece.c72057fe6e448653072791053781927c.svg";
export { ForwardRef as ReactComponent };